import { useMutation } from "@tanstack/react-query";
import { createClass as apiCreate } from "../../api/apiClasses";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateClass() {
    const navigate = useNavigate(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: createClass, isPending, error } = useMutation({
        mutationFn: (req) => apiCreate(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); navigate('/classes'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { isPending, error, createClass };
}
